import Link from 'next/link';

import clsx from 'clsx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import useTranslation from '@/utils/hooks/translation/useTranslation';

dayjs.extend(utc);

// Utils
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
import useUserRole from '@/utils/hooks/user/useUserRole';

// Libs
import { SUBSCRIPTION_INVOICES } from '@/lib/routes/privateRoutes';
import { CHANGE_YOUR_PLAN } from '@/lib/settings/subscriptionInvoices/steps';

export function ReminderTrialEnd() {
    const { t } = useTranslation('layout_platform');
    const { isAdmin } = useUserRole();

    const { subscription } = useSubscription();

    if (subscription?.product_key !== 'trial') {
        return null;
    }

    const expirationDate = dayjs.utc(subscription?.trial_ends_at, 'YYYY-MM-DD HH:mm:ss');
    const daysRemaining = expirationDate.diff(dayjs.utc().startOf('days'), 'days');

    return (
        <div className="flex min-h-10 items-center justify-center gap-1 bg-icoGreen-100 py-3 text-xs dark:bg-icoGreen/20">
            {t(
                clsx({
                    'reminder_trial_end.admin': isAdmin,
                    'reminder_trial_end.team_member': !isAdmin
                }),
                { count: daysRemaining }
            )}
            {isAdmin ? (
                <Link
                    className="text-icoGreen underline"
                    href={{
                        pathname: SUBSCRIPTION_INVOICES,
                        query: { step: CHANGE_YOUR_PLAN }
                    }}>
                    {t('reminder_trial_end.button_upgrade')}
                </Link>
            ) : null}
        </div>
    );
}
